import type { ReactNode } from 'react'
import type { RateTier } from '../../types/electricity'

export function AppShell({ children, tier }: { children: ReactNode; tier?: RateTier }) {
  const greenOpacity = tier === 'offpeak' ? 'opacity-100' : 'opacity-40'
  const redOpacity = tier === 'peak' ? 'opacity-100' : 'opacity-40'

  return (
    <div className="relative min-h-screen overflow-hidden">
      <div className={`blob blob-green animate-blob-1 ${greenOpacity}`} />
      <div className={`blob blob-red animate-blob-2 ${redOpacity}`} />
      <div className="blob blob-yellow animate-blob-1" />

      <div className="relative z-10 mx-auto max-w-[640px] px-4 py-8">
        {children}
      </div>
    </div>
  )
}
